import initialBillingState from "../billing.initialState";
import { reduxActions as BILLING } from "_constants/billing.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";

const aiImages = {
  [BILLING.AI_IMAGES_STARTED]: (state) => ({
    ...state,
    aiImages: {
      ...state.aiImages,
      status: LOADING
    }
  }),

  [BILLING.AI_IMAGES_SUCCESS]: (state, { payload }) => ({
    ...state,
    aiImages: {
      ...state.aiImages,
      data: payload?.data?.[0] ?? null,
      status: SUCCESS
    }
  }),

  [BILLING.AI_IMAGES_FAIL]: (state, { payload }) => ({
    ...state,
    aiImages: {
      ...state.aiImages,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [BILLING.AI_IMAGES_RESET]: (state) => ({
    ...state,
    aiImages: initialBillingState.aiImages
  })
};

export default aiImages;
